import { useTranslation } from "react-i18next";
import { Grid, GridColumn } from "semantic-ui-react";

import { DATE_FORMATS_FNS, DatePicker, Dropdown, usePermanentRealtimeDealers } from "components";
import { DMS_CAPABILITIES, DMS_WARNING_SERVERITIES, DMS_WARNING_SOURCES } from "models";
import "modules/DMSv3/Monitoring/components/DMSv3MonitoringFilters/DMSv3MonitoringFilters.scss";
import { setFilters, useDMSv3MonitoringDashboardFilters } from "modules/DMSv3/Monitoring/hooks";
import { enumToDropdownOptions } from "utils/common";
import { formatDate, toDate } from "utils/dateHelperFunctions";
import { DMS_OPTIONS } from "utils/dms";

export const DMSv3MonitoringFilters = () => {
  const { t } = useTranslation();

  const { data: filters } = useDMSv3MonitoringDashboardFilters();
  const { dealers } = usePermanentRealtimeDealers();

  const dealerOptions = dealers.map(({ id, name }) => ({ key: id, value: id, text: name }));
  const severityOptions = enumToDropdownOptions({ enumObj: DMS_WARNING_SERVERITIES, t });
  const sourceOptions = enumToDropdownOptions({ enumObj: DMS_WARNING_SOURCES, t });
  const capabilityOptions = enumToDropdownOptions({ enumObj: DMS_CAPABILITIES, t });

  const handleDateFilterChange = (dateFrom: Date | null, dateTo: Date | null) => {
    setFilters({
      ...filters,
      date_from: dateFrom ? toDate(formatDate(dateFrom, DATE_FORMATS_FNS.ISOFormatStartOfDay)) : null,
      date_to: dateTo ? toDate(formatDate(dateTo, DATE_FORMATS_FNS.ISOFormatEndOfDay)) : null,
      page: 1
    });
  };

  return (
    <Grid columns="equal" className="DMSv3MonitoringFilters">
      <GridColumn>
        <Dropdown
          fluid
          selection
          search
          clearable
          selectOnBlur={false}
          value={filters.dealer_id}
          options={dealerOptions}
          placeholder={t("v8_filter_by_dealer", "Filter by dealer")}
          onChange={dealer_id => setFilters({ ...filters, dealer_id })}
        />
      </GridColumn>

      <GridColumn>
        <Dropdown
          fluid
          selection
          search
          clearable
          selectOnBlur={false}
          value={filters.dms_id}
          options={DMS_OPTIONS}
          placeholder={t("v8_select_dms", "Select DMS")}
          onChange={dms_id => setFilters({ ...filters, dms_id })}
          className="dms-v3-monitoring-dates-filter"
        />
      </GridColumn>
      <GridColumn>
        <DatePicker
          selectsRange
          showLabel
          clearable
          startDate={filters.date_from}
          endDate={filters.date_to}
          onDateChange={(start, end) => handleDateFilterChange(start, end)}
        />
      </GridColumn>

      <GridColumn>
        <Dropdown
          fluid
          selection
          clearable
          selectOnBlur={false}
          value={filters.severity}
          options={severityOptions}
          placeholder={t("v8_severity", "Severity")}
          onChange={severity => setFilters({ ...filters, severity })}
        />
      </GridColumn>

      <GridColumn>
        <Dropdown
          fluid
          selection
          clearable
          selectOnBlur={false}
          value={filters.source}
          options={sourceOptions}
          placeholder={t("v8_source", "Source")}
          onChange={source => setFilters({ ...filters, source })}
        />
      </GridColumn>

      <GridColumn>
        <Dropdown
          fluid
          selection
          search
          clearable
          selectOnBlur={false}
          value={filters.dms_capability_id}
          options={capabilityOptions}
          placeholder={t("v8_capability", "Capability")}
          onChange={dms_capability_id => setFilters({ ...filters, dms_capability_id })}
        />
      </GridColumn>
    </Grid>
  );
};
